import { Capacitor } from "@capacitor/core";
import { TelegramAPISettings } from "../telegram_api_settings.js";

export const isIOSDevice = (): boolean =>
{
  const user_agent = navigator.userAgent.toLowerCase();
  const has_touch = navigator.maxTouchPoints > 0;

  return /iphone|ipad|ipod/.test( user_agent )
    || ( user_agent.includes( "macintosh" ) && has_touch );
};

export const isIOSWebWithoutNativeHaptics = (): boolean =>
{
  return isIOSDevice()
    && Capacitor.getPlatform() !== "ios"
    && !TelegramAPISettings.isTelegramEnvironment();
};

export const shouldShowHapticsButton = (): boolean =>
{
  const platform = Capacitor.getPlatform();
  if ( platform === 'ios' ) return true;
  if ( platform === 'android' ) return true;
  if ( TelegramAPISettings.isTelegramEnvironment() && isIOSDevice() ) return true;
  return false;
};
